import React from 'react'
import './Footer.css'
import { FaSquareInstagram } from "react-icons/fa6";
import { AiFillTikTok} from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";
import { MdAttachEmail } from "react-icons/md";
import { IoIosCall } from "react-icons/io";

function Footer(props){
    return(
    
        <footer className='footer-container'>
        <li className='footer-items '>
            <a className = 'footer-link' href='https://www.instagram.com/tanas.arrangements/'>
            <FaSquareInstagram className='footer-link-item insta' />
            <h2 className='footer-link-item footer-text ' >Instagram</h2>
            </a>
        </li>
        <li className='footer-items'>
            <a className = 'footer-link' href='https://www.tiktok.com/@tanas.arangments'>
            <AiFillTikTok className='footer-link-item tiktok' />
            <h2 className='footer-link-item footer-text' >Tiktok</h2>
            </a>
        </li>
        <li className='footer-items '>
            <a className = 'footer-link' href='https://www.facebook.com/tatjana.oparaku'>
            <FaFacebookSquare className='footer-link-item facebook' />
            <h2 className='footer-link-item footer-text' >Facebook</h2>
            </a>
        </li>
        <li className='footer-items '>
            <a className = 'footer-link' href='/#/order'>
                <MdAttachEmail className='footer-link-item pinterest' />
                <h2 className='footer-link-item footer-text'>Email Us</h2>
            </a>
        </li>
        <li className='footer-items '>
            <a className = 'footer-link' href='/#/order'>
                <IoIosCall className='footer-link-item pinterest' />
                <h2 className='footer-link-item footer-text'>586 489-9295</h2>
            </a>
        </li>


      </footer>
    
    )
}

export default Footer
